module.exports = __webpack_public_path__ + "0d6a85ff82c6d65cf433421884b8da43.MP3";